export const useSocialMedia = () => ([
  {
    "name": "Facebook",
    "slug": "facebook",
    "link": "https://www.facebook.com/imaginetimisoara/"
  },
  {
    "name": "Instagram",
    "slug": "instagram",
    "link": "https://www.instagram.com/imagine.timisoara/"
  }
]);